"use client";

import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { SnackBarV2 } from "@website/ui/snackbar-v2";
import { useScrollVisibility } from "@website/widget/search-map/animatedButton/use-scroll-visibility.hook";
import { AnimatedTelesales } from "@website/widget/telesales/animatedTelesale";
import { useTelesales } from "@website/widget/telesales/hooks";
import { TelesalesForm } from "@website/widget/telesales/telesales-form";
import { TelesalesPropertiesType } from "@website/widget/telesales/types";
export const Telesales = t0 => {
  const $ = _c(40);
  const {
    isPadding: t1,
    requestData,
    storageKey,
    reasons,
    onButtonClick,
    onSuccess,
    description,
    showAnimatedMobileButton,
    mobileButtonAnimation,
    className,
    isNewPlP
  } = t0;
  const isPadding = t1 === undefined ? false : t1;
  const {
    isOpenModal,
    setIsOpenModal,
    handleOpenModal,
    isSubmitBefore,
    onSubmitSuccess,
    onCloseSnackbar,
    snackbar
  } = useTelesales(storageKey, requestData.app);
  const {
    isMobile
  } = useViewPort();
  let t2;
  if ($[0] !== handleOpenModal || $[1] !== onButtonClick) {
    t2 = () => {
      onButtonClick?.();
      handleOpenModal();
    };
    $[0] = handleOpenModal;
    $[1] = onButtonClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleButtonClick = t2;
  const showScrollAnimatedMobileButton = mobileButtonAnimation === "scroll";
  const isScrollAnimatedButtonVisible = useScrollVisibility(showScrollAnimatedMobileButton);
  const mobileScrollAnimationClassName = showScrollAnimatedMobileButton ? `max-md:transition-transform max-md:duration-300 ${isScrollAnimatedButtonVisible ? "max-md:pointer-events-auto max-md:translate-y-0 max-md:opacity-100" : "max-md:pointer-events-none max-md:translate-y-10 max-md:opacity-0"}` : "";
  const t3 = showAnimatedMobileButton && !showScrollAnimatedMobileButton ? "max-md:hidden" : "";
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon className="absolute right-3 top-2 text-2xl" name="phone_enabled" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `shadow-8 !fixed bottom-6 ${isPadding ? "max-lg:bottom-24 max-md:bottom-36" : ""} right-6 z-[12] gap-3 ${mobileScrollAnimationClassName} ${className ?? ""}`;
  const t6 = isNewPlP && isMobile ? "" : "\u0631\u0632\u0631\u0648 \u062A\u0644\u0641\u0646\u06CC";
  let t7;
  if ($[4] !== handleButtonClick || $[5] !== t5 || $[6] !== t6) {
    t7 = <Button StartIcon={t4} className={t5} color="secondary" onClick={handleButtonClick} size="large" text={t6} variant="round" />;
    $[4] = handleButtonClick;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3 || $[9] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[8] = t3;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== handleButtonClick || $[12] !== showAnimatedMobileButton || $[13] !== showScrollAnimatedMobileButton) {
    t9 = showAnimatedMobileButton && !showScrollAnimatedMobileButton && <div className="md:hidden"><AnimatedTelesales onClick={handleButtonClick} /></div>;
    $[11] = handleButtonClick;
    $[12] = showAnimatedMobileButton;
    $[13] = showScrollAnimatedMobileButton;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== setIsOpenModal) {
    t10 = () => setIsOpenModal(false);
    $[15] = setIsOpenModal;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== setIsOpenModal) {
    t11 = () => setIsOpenModal(false);
    $[17] = setIsOpenModal;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== description || $[20] !== isSubmitBefore || $[21] !== onSubmitSuccess || $[22] !== onSuccess || $[23] !== reasons || $[24] !== requestData || $[25] !== storageKey || $[26] !== t11) {
    t12 = <TelesalesForm description={description} isSubmitBefore={isSubmitBefore} onClose={t11} onSubmitSuccess={onSubmitSuccess} onSuccess={onSuccess} reasons={reasons} requestData={requestData} storageKey={storageKey} />;
    $[19] = description;
    $[20] = isSubmitBefore;
    $[21] = onSubmitSuccess;
    $[22] = onSuccess;
    $[23] = reasons;
    $[24] = requestData;
    $[25] = storageKey;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== isOpenModal || $[29] !== t10 || $[30] !== t12) {
    t13 = <Modal className="flex gap-6 lg:max-w-[448px]" headerStyle="text-headline-6 m-0" mobileHeight="auto" onClose={t10} open={isOpenModal} showCloseButton={true} title={"\u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0631\u0632\u0631\u0648 \u062A\u0644\u0641\u0646\u06CC"}>{t12}</Modal>;
    $[28] = isOpenModal;
    $[29] = t10;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== onCloseSnackbar || $[33] !== snackbar) {
    t14 = <SnackBarV2 {...snackbar} onClose={onCloseSnackbar} />;
    $[32] = onCloseSnackbar;
    $[33] = snackbar;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t13 || $[36] !== t14 || $[37] !== t8 || $[38] !== t9) {
    t15 = <>{t8}{t9}{t13}{t14}</>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t8;
    $[38] = t9;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
};